import React from 'react';
import useThemeColor from '../../../hooks/useThemeColor';
import './ToggleSwitch.css';  

const ToggleSwitch = ({
  isChecked,
  onToggle,
  label,
  name,
  disabled = false,
  className = '',
  colorTheme = 'default', // 'default', 'green', 'red', 'purple', 'orange'
  size = 'default', // 'small', 'default', 'large'
}) => {
  const themeColor = useThemeColor();
  const getSizeClass = () => {
    switch(size) {
      case 'small': return 'toggle-switch-small';
      case 'large': return 'toggle-switch-large';
      default: return '';
    }
  };

  const getColorClass = () => {
    if (colorTheme === 'default') return '';
    return `toggle-switch-${colorTheme}`;
  };

  // FIX: Extract the checked value from the event before passing to onToggle
  const handleChange = (e) => {
    onToggle(e.target.checked);
  };

  return (
    <div className={`d-flex align-items-center ${className}`}>
      <div className={`toggle-switch ${isChecked ? 'active' : ''} ${getColorClass()} ${getSizeClass()}`}>
        <label className="switch">
          <input
            type="checkbox"
            name={name}
            checked={isChecked}
            onChange={handleChange}
            disabled={disabled}
          />
          <span 
            className="slider round"
            style={themeColor ? {
              backgroundColor: isChecked ? themeColor : '#ccc'
            } : {}}
          ></span>
        </label>
      </div>
      {label && <span className="ms-1 mb-1">{label}</span>}
    </div>
  );
};

export default ToggleSwitch;